<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-01-11 16:26:37
-->
<template>
  <div id="footer" class="footer">
    <div  class="footer-contianer">
      <el-row type="flex" justify="center">
        <el-col :span="24" class="login-copy">
          <div>
            版权所有Copyright © 2025 上海文策信息科技有限公司 All rights
            reserved
          </div>
          <p class="footer-info">
            <a
              :underline="false"
              href="https://beian.miit.gov.cn"
              target="_blank"
              >沪ICP备2024075500号-2
            </a>
          </p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.copyright {
  padding: 0 0 0px 20px;
  margin: 10px;
}
.footer{
  padding-top: 10px;
  background: white;
}

.footer .footer-contianer {
  background: white;
  display: flex;
  justify-content: center;
  .login-copy {
    text-align: center;
    color: #505050;
    font-size: 14px;
    .footer-info {
      a {
        text-decoration: none;
        border-bottom: none;
        color: gray;
      }
      a:hover {
        color: #409eff;
      }
    }
  }
}
</style>
